// IA Conforme - Données statiques (Contenu français)

export const SECTORS = [
  { id: "sante", label: "Santé", icon: "Heart" },
  { id: "finance", label: "Finance & Banque", icon: "Landmark" },
  { id: "rh", label: "Ressources Humaines", icon: "Users" },
  { id: "tech", label: "Tech & SaaS", icon: "Cpu" },
  { id: "ecommerce", label: "E-commerce", icon: "ShoppingCart" },
  { id: "education", label: "Éducation", icon: "GraduationCap" },
  { id: "juridique", label: "Juridique", icon: "Scale" },
  { id: "industrie", label: "Industrie", icon: "Factory" },
  { id: "immobilier", label: "Immobilier", icon: "Building" },
  { id: "autre", label: "Autre", icon: "Briefcase" },
];

export const STRUCTURES = [
  { id: "independant", label: "Indépendant / Freelance" },
  { id: "tpe", label: "TPE (< 10 salariés)" },
  { id: "pme", label: "PME (10-250 salariés)" },
  { id: "eti", label: "ETI (250-5000 salariés)" },
  { id: "grande", label: "Grande entreprise (> 5000)" },
];

export const RISKS = [
  {
    id: "unacceptable",
    level: "Inacceptable",
    color: "#DC2626",
    bgColor: "#FEF2F2",
    icon: "Ban",
    description: "Systèmes IA totalement interdits par l'AI Act car ils représentent une menace claire pour les droits fondamentaux.",
    rules: ["Manipulation subliminale ou trompeuse", "Exploitation des vulnérabilités (âge, handicap)", "Notation sociale (social scoring)", "Identification biométrique en temps réel dans l'espace public (sauf exceptions)"],
    avoid: ["Utiliser l'IA pour manipuler les comportements", "Créer des systèmes de notation des citoyens", "Déployer de la reconnaissance faciale en temps réel sans cadre légal"],
    precautions: ["Vérifier que votre système ne tombe pas dans cette catégorie", "Consulter un juriste en cas de doute", "Documenter l'analyse de risque"],
    examples: ["Score social à la chinoise", "Manipulation comportementale des enfants", "Reconnaissance faciale de masse non autorisée"]
  },
  {
    id: "high",
    level: "Élevé",
    color: "#F59E0B",
    bgColor: "#FFFBEB",
    icon: "AlertTriangle",
    description: "Systèmes IA à haut risque nécessitant une conformité stricte : évaluation, documentation, surveillance humaine.",
    rules: ["Évaluation de conformité obligatoire avant mise sur le marché", "Système de gestion des risques", "Gouvernance des données", "Documentation technique détaillée", "Journalisation et traçabilité", "Surveillance humaine obligatoire"],
    avoid: ["Déployer sans évaluation de conformité", "Utiliser des données biaisées sans correction", "Supprimer la surveillance humaine"],
    precautions: ["Mettre en place un système de gestion de la qualité", "Former les utilisateurs", "Prévoir des mécanismes de recours"],
    examples: ["IA de recrutement / tri de CV", "IA de diagnostic médical", "IA de scoring crédit", "IA de gestion des infrastructures critiques", "IA dans l'éducation (notation automatique)"]
  },
  {
    id: "limited",
    level: "Limité",
    color: "#3B82F6",
    bgColor: "#EFF6FF",
    icon: "Info",
    description: "Systèmes IA avec obligations de transparence. L'utilisateur doit savoir qu'il interagit avec une IA.",
    rules: ["Obligation d'informer l'utilisateur qu'il interagit avec une IA", "Signaler les contenus générés par IA (deepfakes, textes)", "Transparence sur le fonctionnement du système"],
    avoid: ["Faire passer l'IA pour un humain", "Générer du contenu trompeur sans mention", "Cacher l'utilisation de l'IA"],
    precautions: ["Afficher clairement les mentions IA", "Documenter les sources et méthodes", "Mettre en place des filtres de contenu"],
    examples: ["Chatbot client", "Générateur de texte / images", "Système de recommandation", "Assistant virtuel"]
  },
  {
    id: "minimal",
    level: "Minimal",
    color: "#10B981",
    bgColor: "#F0FDF4",
    icon: "CheckCircle",
    description: "Systèmes IA à risque minimal. Pas d'obligations spécifiques de l'AI Act, mais les bonnes pratiques RGPD s'appliquent toujours.",
    rules: ["Pas d'obligations spécifiques AI Act", "Respect du RGPD pour les données personnelles", "Bonnes pratiques recommandées"],
    avoid: ["Collecter des données inutiles", "Négliger la sécurité des données", "Ignorer les droits des personnes"],
    precautions: ["Appliquer le principe de minimisation", "Documenter vos traitements", "Respecter les droits des personnes concernées"],
    examples: ["Filtre anti-spam", "IA de jeu vidéo", "Optimisation logistique", "Maintenance prédictive"]
  }
];

export const CHECKLIST_ITEMS = [
  { id: "rgpd-1", category: "RGPD", label: "Registre des traitements à jour", description: "Tenir un registre conforme à l'article 30 du RGPD" },
  { id: "rgpd-2", category: "RGPD", label: "Base légale identifiée", description: "Consentement, contrat, intérêt légitime, obligation légale..." },
  { id: "rgpd-3", category: "RGPD", label: "Information des personnes", description: "Politique de confidentialité claire et accessible" },
  { id: "rgpd-4", category: "RGPD", label: "Droits des personnes respectés", description: "Accès, rectification, suppression, portabilité, opposition" },
  { id: "rgpd-5", category: "RGPD", label: "Mesures de sécurité en place", description: "Chiffrement, contrôle d'accès, sauvegardes" },
  { id: "rgpd-6", category: "RGPD", label: "DPO désigné si nécessaire", description: "Obligatoire pour certaines structures" },
  { id: "aact-1", category: "AI Act", label: "Classification du risque effectuée", description: "Identifier le niveau de risque de votre système IA" },
  { id: "aact-2", category: "AI Act", label: "Évaluation de conformité réalisée", description: "Pour les systèmes à haut risque" },
  { id: "aact-3", category: "AI Act", label: "Documentation technique complète", description: "Description du système, données, performances" },
  { id: "aact-4", category: "AI Act", label: "Surveillance humaine prévue", description: "Mécanismes de contrôle humain en place" },
  { id: "aact-5", category: "AI Act", label: "Transparence assurée", description: "Information claire sur l'utilisation de l'IA" },
  { id: "aact-6", category: "AI Act", label: "Gestion des biais documentée", description: "Mesures contre les discriminations algorithmiques" },
  { id: "prat-1", category: "Pratiques", label: "AIPD réalisée si nécessaire", description: "Analyse d'impact sur la protection des données" },
  { id: "prat-2", category: "Pratiques", label: "Formation des équipes", description: "Sensibilisation du personnel à la conformité IA" },
  { id: "prat-3", category: "Pratiques", label: "Processus de mise à jour", description: "Veille réglementaire et évolution du système" },
  { id: "prat-4", category: "Pratiques", label: "Plan de continuité", description: "Que faire en cas de défaillance du système IA" },
];

export const QUIZ_QUESTIONS = [
  {
    question: "Quel est le niveau de risque le plus élevé selon l'AI Act ?",
    options: ["Minimal", "Limité", "Élevé", "Inacceptable"],
    correct: 3,
    explanation: "Le risque « Inacceptable » correspond aux systèmes IA totalement interdits car ils menacent les droits fondamentaux."
  },
  {
    question: "Que signifie RGPD ?",
    options: ["Règlement Général pour la Politique Digitale", "Règlement Général sur la Protection des Données", "Règles Générales de Prévention Digitale", "Régulation Globale des Plateformes Digitales"],
    correct: 1,
    explanation: "Le RGPD est le Règlement Général sur la Protection des Données, en vigueur depuis mai 2018."
  },
  {
    question: "Qu'est-ce qu'un DPO ?",
    options: ["Digital Project Officer", "Délégué à la Protection des Données", "Data Processing Operator", "Director of Privacy Operations"],
    correct: 1,
    explanation: "Le DPO (Data Protection Officer) est le Délégué à la Protection des Données, responsable de la conformité RGPD."
  },
  {
    question: "Une IA de tri de CV est classée à quel niveau de risque ?",
    options: ["Minimal", "Limité", "Élevé", "Inacceptable"],
    correct: 2,
    explanation: "Les systèmes IA utilisés dans le recrutement sont classés « haut risque » car ils impactent directement les droits des personnes."
  },
  {
    question: "L'obligation de transparence signifie que :",
    options: ["Le code source doit être public", "L'utilisateur doit savoir qu'il interagit avec une IA", "Toutes les données doivent être accessibles", "L'IA doit expliquer chaque décision"],
    correct: 1,
    explanation: "L'obligation de transparence impose d'informer clairement l'utilisateur qu'il interagit avec un système d'IA."
  },
  {
    question: "Quand l'AI Act entre-t-il pleinement en application ?",
    options: ["2024", "2025", "2026", "2027"],
    correct: 2,
    explanation: "L'AI Act entre en application de manière progressive, avec une application complète prévue pour 2026-2027."
  },
  {
    question: "Le social scoring (notation sociale) est :",
    options: ["Autorisé sous conditions", "Limité aux gouvernements", "Interdit par l'AI Act", "Autorisé pour les entreprises"],
    correct: 2,
    explanation: "La notation sociale est classée comme risque inacceptable et est interdite par l'AI Act."
  },
  {
    question: "Qu'est-ce qu'une AIPD ?",
    options: ["Autorisation d'Intelligence Pré-Déployée", "Analyse d'Impact sur la Protection des Données", "Audit Interne de Performance Digitale", "Association pour l'Innovation et la Protection Digitale"],
    correct: 1,
    explanation: "L'AIPD est l'Analyse d'Impact relative à la Protection des Données, obligatoire pour les traitements à risque élevé."
  },
  {
    question: "Un chatbot client est classé à quel niveau de risque ?",
    options: ["Inacceptable", "Élevé", "Limité", "Minimal"],
    correct: 2,
    explanation: "Un chatbot client est généralement classé « risque limité » avec une obligation de transparence : informer l'utilisateur qu'il parle à une IA."
  },
  {
    question: "Le RGPD s'applique-t-il aux systèmes IA ?",
    options: ["Non, seul l'AI Act s'applique", "Oui, dès que des données personnelles sont traitées", "Uniquement pour les systèmes à haut risque", "Seulement en France"],
    correct: 1,
    explanation: "Le RGPD s'applique à tout traitement de données personnelles, y compris par des systèmes d'IA, dans toute l'Union Européenne."
  }
];

export const GLOSSARY = [
  { term: "RGPD", definition: "Règlement Général sur la Protection des Données. Règlement européen en vigueur depuis le 25 mai 2018 qui encadre le traitement des données personnelles." },
  { term: "AI Act", definition: "Règlement européen sur l'intelligence artificielle adopté en 2024. Premier cadre juridique complet au monde pour réguler l'IA selon une approche basée sur les risques." },
  { term: "DPO", definition: "Délégué à la Protection des Données (Data Protection Officer). Personne chargée de veiller à la conformité RGPD au sein d'un organisme." },
  { term: "AIPD", definition: "Analyse d'Impact relative à la Protection des Données. Évaluation obligatoire pour les traitements susceptibles d'engendrer un risque élevé pour les droits des personnes." },
  { term: "CNIL", definition: "Commission Nationale de l'Informatique et des Libertés. Autorité française de protection des données personnelles." },
  { term: "Consentement", definition: "Manifestation de volonté libre, spécifique, éclairée et univoque par laquelle la personne accepte le traitement de ses données." },
  { term: "Minimisation", definition: "Principe du RGPD imposant de ne collecter que les données strictement nécessaires à la finalité du traitement." },
  { term: "Profilage", definition: "Toute forme de traitement automatisé de données personnelles visant à évaluer certains aspects personnels d'une personne physique." },
  { term: "Privacy by Design", definition: "Approche consistant à intégrer la protection des données dès la conception d'un système ou service." },
  { term: "Droit à l'oubli", definition: "Droit pour une personne d'obtenir l'effacement de ses données personnelles dans certaines conditions (art. 17 RGPD)." },
  { term: "Base légale", definition: "Fondement juridique autorisant un traitement de données : consentement, contrat, obligation légale, intérêt vital, mission publique ou intérêt légitime." },
  { term: "Responsable de traitement", definition: "Organisme qui détermine les finalités et les moyens du traitement des données personnelles." },
  { term: "Sous-traitant", definition: "Organisme qui traite des données personnelles pour le compte du responsable de traitement." },
  { term: "Sandbox réglementaire", definition: "Environnement contrôlé mis en place par les autorités pour tester des systèmes IA innovants dans un cadre réglementaire allégé." },
  { term: "Système IA à haut risque", definition: "Catégorie de l'AI Act englobant les systèmes IA susceptibles d'affecter les droits fondamentaux et nécessitant une conformité stricte." },
];

export const TIMELINE = [
  {
    date: "Août 2024",
    title: "Entrée en vigueur de l'AI Act",
    description: "Publication au Journal Officiel de l'UE et début de la période transitoire.",
    impact: "Début de la préparation pour toutes les entreprises utilisant l'IA.",
    concerned: ["Toutes les entreprises"],
    actions: ["Commencer l'audit de vos systèmes IA", "Identifier les classifications de risque"]
  },
  {
    date: "Février 2025",
    title: "Interdiction des pratiques inacceptables",
    description: "Les systèmes IA classés « risque inacceptable » sont officiellement interdits.",
    impact: "Arrêt obligatoire des systèmes de notation sociale, manipulation subliminale, etc.",
    concerned: ["Entreprises utilisant des systèmes IA à risque inacceptable"],
    actions: ["Vérifier qu'aucun système ne tombe dans cette catégorie", "Arrêter tout système concerné"]
  },
  {
    date: "Août 2025",
    title: "Obligations pour les modèles d'IA à usage général",
    description: "Les fournisseurs de modèles d'IA génératifs doivent se conformer (transparence, documentation).",
    impact: "Obligation de documentation et de transparence pour les grands modèles.",
    concerned: ["Fournisseurs de modèles IA", "Tech", "SaaS"],
    actions: ["Documenter les modèles utilisés", "Assurer la transparence sur les données d'entraînement"]
  },
  {
    date: "Août 2026",
    title: "Application complète pour les systèmes à haut risque",
    description: "Toutes les obligations pour les systèmes IA à haut risque entrent en vigueur.",
    impact: "Évaluation de conformité, documentation technique, surveillance humaine obligatoires.",
    concerned: ["Santé", "Finance", "RH", "Éducation", "Justice"],
    actions: ["Réaliser l'évaluation de conformité", "Mettre en place la surveillance humaine", "Compléter la documentation technique"]
  },
  {
    date: "Août 2027",
    title: "Application aux produits réglementés",
    description: "Extension aux systèmes IA intégrés dans des produits soumis à d'autres réglementations (médical, automobile, etc.).",
    impact: "Double conformité : AI Act + réglementation sectorielle.",
    concerned: ["Industrie", "Médical", "Automobile", "Aéronautique"],
    actions: ["Vérifier la conformité croisée", "Adapter les processus de certification"]
  }
];

export const SCENARIOS = [
  { id: "recrutement", title: "IA de recrutement", description: "Tri automatisé de CV et pré-sélection de candidats", risk: "high", sector: "rh" },
  { id: "chatbot", title: "Chatbot client", description: "Assistant virtuel pour le service client", risk: "limited", sector: "ecommerce" },
  { id: "diagnostic", title: "IA de diagnostic médical", description: "Aide au diagnostic par analyse d'images médicales", risk: "high", sector: "sante" },
  { id: "credit", title: "Scoring crédit", description: "Évaluation automatisée de la solvabilité", risk: "high", sector: "finance" },
  { id: "marketing", title: "IA marketing", description: "Personnalisation et ciblage publicitaire", risk: "limited", sector: "ecommerce" },
  { id: "surveillance", title: "Surveillance vidéo", description: "Analyse vidéo avec reconnaissance de comportements", risk: "high", sector: "autre" },
  { id: "notation", title: "Notation automatique", description: "Système de notation des élèves par IA", risk: "high", sector: "education" },
  { id: "recommandation", title: "Système de recommandation", description: "Suggestions de contenu ou produits", risk: "minimal", sector: "tech" },
];

export const CASE_STUDIES = [
  {
    id: "cs-1", sector: "sante", title: "IA d'aide au diagnostic radiologique",
    risk: "high",
    description: "Un hôpital déploie un système d'IA pour analyser les radiographies et détecter des anomalies.",
    regulations: ["AI Act - Système à haut risque (Annexe III)", "RGPD - Données de santé (art. 9)", "Code de la santé publique"],
    pitfalls: ["Utiliser des données non anonymisées pour l'entraînement", "Remplacer complètement le médecin sans supervision", "Ne pas documenter les performances du modèle"],
    actions: ["Réaliser une AIPD avant déploiement", "Maintenir la décision finale par un professionnel de santé", "Documenter les performances (sensibilité, spécificité)", "Former le personnel médical à l'interprétation des résultats"]
  },
  {
    id: "cs-2", sector: "finance", title: "Scoring crédit automatisé",
    risk: "high",
    description: "Une banque utilise l'IA pour évaluer la solvabilité des demandeurs de prêt.",
    regulations: ["AI Act - Système à haut risque", "RGPD - Décisions individuelles automatisées (art. 22)", "Réglementation bancaire (Bâle III/IV)"],
    pitfalls: ["Biais discriminatoires dans les données historiques", "Opacité du modèle vis-à-vis des clients", "Absence de recours humain"],
    actions: ["Auditer régulièrement les biais du modèle", "Proposer un droit d'explication au client", "Prévoir une voie de recours auprès d'un humain", "Documenter les critères de décision"]
  },
  {
    id: "cs-3", sector: "rh", title: "Pré-sélection IA de candidatures",
    risk: "high",
    description: "Un cabinet RH utilise l'IA pour filtrer et classer les candidatures reçues.",
    regulations: ["AI Act - Système à haut risque (recrutement)", "RGPD - Profilage (art. 22)", "Code du travail - Non-discrimination"],
    pitfalls: ["Reproduction des biais historiques (genre, âge, origine)", "Manque de transparence envers les candidats", "Collecte excessive de données"],
    actions: ["Auditer le modèle contre les biais discriminatoires", "Informer les candidats de l'utilisation de l'IA", "Permettre un recours humain", "Minimiser les données collectées"]
  },
  {
    id: "cs-4", sector: "ecommerce", title: "Chatbot e-commerce avec IA générative",
    risk: "limited",
    description: "Un site e-commerce déploie un chatbot IA pour assister les clients dans leurs achats.",
    regulations: ["AI Act - Risque limité (obligation de transparence)", "RGPD - Traitement des données clients", "Droit de la consommation"],
    pitfalls: ["Ne pas informer que c'est une IA", "Stocker les conversations sans consentement", "Donner des informations incorrectes sur les produits"],
    actions: ["Afficher clairement qu'il s'agit d'un assistant IA", "Limiter la conservation des conversations", "Prévoir un transfert vers un humain", "Mettre en place des garde-fous sur les réponses"]
  },
  {
    id: "cs-5", sector: "education", title: "Système de notation automatique",
    risk: "high",
    description: "Une université utilise l'IA pour noter automatiquement les copies d'examen.",
    regulations: ["AI Act - Système à haut risque (éducation)", "RGPD - Décisions individuelles automatisées", "Code de l'éducation"],
    pitfalls: ["Biais dans la notation (style, vocabulaire)", "Absence de recours pour les étudiants", "Non-transparence des critères"],
    actions: ["Maintenir une vérification humaine des notes", "Publier les critères d'évaluation utilisés", "Permettre la contestation des résultats", "Former les enseignants au fonctionnement du système"]
  },
  {
    id: "cs-6", sector: "tech", title: "Système de recommandation personnalisée",
    risk: "minimal",
    description: "Une plateforme SaaS utilise l'IA pour recommander du contenu pertinent à ses utilisateurs.",
    regulations: ["RGPD - Profilage et consentement", "AI Act - Risque minimal", "Directive e-Privacy"],
    pitfalls: ["Créer des bulles de filtre", "Collecter des données excessives", "Ne pas offrir d'option de désactivation"],
    actions: ["Proposer un contrôle utilisateur sur les recommandations", "Être transparent sur les critères utilisés", "Minimiser les données collectées", "Offrir une option de désactivation"]
  }
];

export const DIAGNOSTIC_QUESTIONS = [
  {
    id: "dq-1",
    question: "Quel type de données votre système IA traite-t-il ?",
    options: [
      { label: "Aucune donnée personnelle", score: 0 },
      { label: "Données personnelles basiques (nom, email)", score: 1 },
      { label: "Données sensibles (santé, biométrie, opinions)", score: 3 },
      { label: "Données de catégories spéciales (origine, religion)", score: 4 }
    ]
  },
  {
    id: "dq-2",
    question: "Quel impact les décisions de l'IA ont-elles sur les personnes ?",
    options: [
      { label: "Aucun impact direct", score: 0 },
      { label: "Impact faible (recommandations)", score: 1 },
      { label: "Impact modéré (filtrage, priorisation)", score: 2 },
      { label: "Impact fort (décisions juridiques, financières, médicales)", score: 4 }
    ]
  },
  {
    id: "dq-3",
    question: "Les personnes concernées sont-elles des populations vulnérables ?",
    options: [
      { label: "Non", score: 0 },
      { label: "Potentiellement (grand public)", score: 1 },
      { label: "Oui (enfants, personnes âgées, patients)", score: 3 },
      { label: "Oui, dans un contexte de dépendance (employés, élèves)", score: 3 }
    ]
  },
  {
    id: "dq-4",
    question: "Existe-t-il une supervision humaine du système ?",
    options: [
      { label: "Oui, décision finale toujours humaine", score: 0 },
      { label: "Oui, vérification régulière", score: 1 },
      { label: "Partielle, uniquement en cas d'alerte", score: 2 },
      { label: "Non, le système est totalement autonome", score: 4 }
    ]
  },
  {
    id: "dq-5",
    question: "Dans quel domaine votre système IA opère-t-il ?",
    options: [
      { label: "Divertissement, jeux, loisirs", score: 0 },
      { label: "Commerce, marketing, communication", score: 1 },
      { label: "Éducation, emploi, services publics", score: 3 },
      { label: "Santé, justice, sécurité, finance", score: 4 }
    ]
  }
];

export const SUGGESTED_QUESTIONS = [
  "Quelles sont les obligations RGPD pour un système d'IA ?",
  "Comment classifier le risque de mon projet IA selon l'AI Act ?",
  "Qu'est-ce qu'une AIPD et quand est-elle obligatoire ?",
  "Quelles sont les sanctions en cas de non-conformité à l'AI Act ?",
  "Comment assurer la transparence de mon système IA ?",
  "Quelles sont les bonnes pratiques pour un chatbot conforme ?",
];

// Curated popular OpenRouter models — full list loaded dynamically via /api/admin/openrouter-models.
// "openrouter" group uses the OpenRouter universal key (no per-provider key needed).
// "custom" group still requires the user's own provider-specific API key.
export const LLM_PROVIDERS = [
  // Anthropic via OpenRouter
  { provider: "openrouter", model: "anthropic/claude-sonnet-4.5", label: "Claude Sonnet 4.5 (Anthropic)", group: "openrouter" },
  { provider: "openrouter", model: "anthropic/claude-haiku-4.5", label: "Claude Haiku 4.5 (Anthropic)", group: "openrouter" },
  { provider: "openrouter", model: "anthropic/claude-opus-4.1", label: "Claude Opus 4.1 (Anthropic)", group: "openrouter" },
  // OpenAI via OpenRouter
  { provider: "openrouter", model: "openai/gpt-4o", label: "GPT-4o (OpenAI)", group: "openrouter" },
  { provider: "openrouter", model: "openai/gpt-4o-mini", label: "GPT-4o Mini (OpenAI)", group: "openrouter" },
  // Google via OpenRouter
  { provider: "openrouter", model: "google/gemini-2.5-flash", label: "Gemini 2.5 Flash (Google) — économique", group: "openrouter" },
  { provider: "openrouter", model: "google/gemini-2.5-flash-lite", label: "Gemini 2.5 Flash Lite (Google)", group: "openrouter" },
  { provider: "openrouter", model: "google/gemini-2.5-pro", label: "Gemini 2.5 Pro (Google)", group: "openrouter" },
  // Mistral via OpenRouter
  { provider: "openrouter", model: "mistralai/mistral-large-2411", label: "Mistral Large (Mistral)", group: "openrouter" },
  { provider: "openrouter", model: "mistralai/mistral-medium-2508", label: "Mistral Medium (Mistral)", group: "openrouter" },
  // DeepSeek via OpenRouter
  { provider: "openrouter", model: "deepseek/deepseek-chat", label: "DeepSeek Chat (DeepSeek) — très économique", group: "openrouter" },
  { provider: "openrouter", model: "deepseek/deepseek-reasoner", label: "DeepSeek Reasoner (DeepSeek)", group: "openrouter" },
  // Meta Llama via OpenRouter
  { provider: "openrouter", model: "meta-llama/llama-3.3-70b-instruct", label: "Llama 3.3 70B (Meta)", group: "openrouter" },
  // xAI via OpenRouter
  { provider: "openrouter", model: "x-ai/grok-4", label: "Grok 4 (xAI)", group: "openrouter" },

  // Custom direct providers (user-supplied API key required)
  { provider: "mistral", model: "mistral-large-latest", label: "Mistral Large (clé directe)", group: "custom" },
  { provider: "deepseek", model: "deepseek-chat", label: "DeepSeek Chat (clé directe)", group: "custom" },
  { provider: "grok", model: "grok-4-fast-reasoning", label: "Grok 4 Fast (clé directe)", group: "custom" },
  { provider: "google", model: "gemini-2.5-flash", label: "Gemini 2.5 Flash (clé Google directe)", group: "custom" },
];
